var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 239,
    viewBox: "0 0 168 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.354 76.5199V13.7282C167.354 10.0873 165.902 6.59546 163.318 4.02091C160.734 1.44636 157.23 0 153.575 0H13.7784C10.1242 0 6.61958 1.44636 4.03563 4.02091C1.45167 6.59546 0 10.0873 0 13.7282V76.5199C0 80.1609 1.45167 83.6527 4.03563 86.2272C6.61958 88.8018 10.1242 90.2482 13.7784 90.2482H63.1007C67.8102 90.2482 72.327 92.1119 75.6575 95.4296C78.9881 98.7473 80.8596 103.247 80.8607 107.94V206.031C80.8144 212.115 78.8249 218.027 75.1807 222.91C74.1174 224.361 73.4802 226.078 73.3402 227.869C73.2002 229.66 73.563 231.455 74.3879 233.052C75.2129 234.65 76.4675 235.987 78.0116 236.915C79.5557 237.843 81.3283 238.325 83.1314 238.306C84.9344 238.288 86.6969 237.77 88.2216 236.811C89.7463 235.852 90.9733 234.489 91.7654 232.875C92.5574 231.261 92.8833 229.46 92.7066 227.672C92.53 225.884 91.8577 224.18 90.7649 222.751C87.1162 217.92 85.1599 212.029 85.1963 205.983V107.932C85.1973 103.24 87.0684 98.7406 90.3981 95.4231C93.7277 92.1055 98.2435 90.2413 102.952 90.2402H153.583C157.235 90.2381 160.736 88.7919 163.318 86.2193C165.9 83.6467 167.352 80.1581 167.354 76.5199Z",
    fill: "#9ECD54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline1);
export default __webpack_public_path__ + "static/media/timeline_1.a2bb676984837b155dd234cbb4c4226a.svg";
export { ForwardRef as ReactComponent };